import React from 'react';
import { COLORS } from 'Components/utils/color/colors';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ArrowButton } from 'Components/frameworks/arrow-button/ArrowButton';
type Props = {
  className?: string;
  index: number;
  isNextControlDisabled: boolean;
  isPreviousControlDisabled: boolean;
  onNext: () => void;
  onPrevious: () => void;
  total: number;
};
export const EventAnimationControls = ({
  className,
  index,
  isNextControlDisabled,
  isPreviousControlDisabled,
  onNext,
  onPrevious,
  total,
}: Props) => (
  <div className={classnames(className, 'flex items-center justify-center gap-20')}>
    <ArrowButton
      className="h-12 flex-none text-8"
      color={COLORS.TRANSPARENT}
      isDisabled={isPreviousControlDisabled}
      label={t('common.previous')}
      onClick={onPrevious}
      theme="ghost"
    />
    <span className="flex items-baseline justify-center text-12 text-black">
      <span className="text-14 font-bold">{index + 1}</span>/{total}
    </span>
    <ArrowButton
      className="h-12 flex-none text-8"
      color={COLORS.TRANSPARENT}
      isDisabled={isNextControlDisabled}
      label={t('common.next')}
      onClick={onNext}
      rotation={180}
      theme="ghost"
    />
  </div>
);
